import { render, staticRenderFns } from "./DobDisplay.vue?vue&type=template&id=5669660a&scoped=true"
import script from "./DobDisplay.vue?vue&type=script&lang=js"
export * from "./DobDisplay.vue?vue&type=script&lang=js"
import style0 from "./DobDisplay.vue?vue&type=style&index=0&id=5669660a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5669660a",
  null
  
)

export default component.exports